import {EventsTab} from '@hconnect/common/types'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import {alpha, ToggleButton, ToggleButtonGroup} from '@mui/material'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type ShiftEventsTabToggleProps = {
  activeTab: EventsTab
  setActiveTab: (tab: EventsTab) => void
  plantId: string
}

export const ShiftEventsTabToggle: FC<ShiftEventsTabToggleProps> = ({
  activeTab,
  setActiveTab,
  plantId
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const hideTabsWorkOrderNotification = useCommonFeatureFlag(
    FeatureFlagKey.HideWorkOrderNotification,
    {plantId}
  )

  return (
    <>
      {hideTabsWorkOrderNotification ? (
        <ToggleButtonGroup
          color="primary"
          sx={({palette}) => ({
            border: `1px solid ${alpha(palette.text.primary, 0.125)}`
          })}
          fullWidth
          exclusive
          value={activeTab}
          onChange={(event: React.MouseEvent<HTMLElement>, value: EventsTab) => {
            if (value) setActiveTab(value)
          }}
        >
          {Object.values(EventsTab).map((codeType: EventsTab) => (
            <ToggleButton
              key={codeType}
              value={codeType}
              sx={({palette}) => ({
                color: palette.text.primary,
                whiteSpace: 'nowrap',
                '&.MuiToggleButtonGroup-grouped:not(.Mui-selected)': {
                  color: palette.text.primary,
                  border: 'none',
                  '&:hover': {
                    backgroundColor: 'transparent'
                  }
                }
              })}
              data-test-id={`events-type-${codeType}`}
            >
              {t(`shiftEvent.tab.${codeType}`)}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      ) : (
        <span>{Object.values(EventsTab.Events)}</span>
      )}
    </>
  )
}
